import { functions } from "@/firebase";

export function sendForm({
  isCustomForm,
  hotelID,
  currency,
  formData,
  formID,
  formTitle,
  targetEmail,
  items,
}) {
  return functions.httpsCallable("sendForm")({
    isCustomForm,
    hotelID,
    currency,
    formData,
    formID,
    formTitle,
    targetEmail,
    items,
  });
}

export function redeemVoucher({ hotelID, voucherID, guestID = null }) {
  return functions.httpsCallable("redeemVoucher")({
    hotelID,
    voucherID,
    guestID,
  });
}

export function trackBehavior({
  action,
  clickedInfo,
  guestID,
  eventID,
  customerID,
  page = null,
  type = null,
}) {
  return functions.httpsCallable("trackBehavior")({
    action,
    clickedInfo,
    guestID,
    eventID,
    customerID,
    page,
    type,
  });
}
